import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlayButtonController } from './play-button.controller';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgStyle } from '@angular/common';

/**
 * Renders a big round play button with play icon in the center.
 */
@Component({
  selector: 'pv2-round-play-button',
  templateUrl: 'round-play-button.component.html',
  styleUrl: 'play-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FaIconComponent, NgStyle],
})
export class Pv2RoundPlayButtonComponent extends PlayButtonController {}
